import {
  Alert,
  AlertTitle,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
} from "@mui/material";
import { DecoratedSchedulerOption } from "./SchedulerScreen";
import { useZonedDateFormat } from "~/providers/ZonedDateFormatProvider";

type Props = {
  options: DecoratedSchedulerOption[];
  selectedOption: DecoratedSchedulerOption | null;
  setSelectedOption: (option: DecoratedSchedulerOption | null) => void;
  timezone: string;
};

export default function SchedulerBestAvailableOptions({
  options,
  selectedOption,
  setSelectedOption,
  timezone,
}: Props) {
  const { timeRangeLabel, timeLabel } = useZonedDateFormat();

  if (!options?.length) {
    return null;
  }

  return (
    <Alert severity="info" icon={false}>
      <AlertTitle>Best Available Options</AlertTitle>
      <FormControl>
        <RadioGroup name="radio-buttons-group">
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            {options.map((option) => {
              const zeroOffsetArrivalWindow = new Date(option.arrivalWindowStart).getTime() === new Date(option.arrivalWindowEnd).getTime();
              const time = zeroOffsetArrivalWindow ?
                timeLabel(option.startTime, true, timezone) :
                timeRangeLabel(option.arrivalWindowStart, option.arrivalWindowEnd, false, false, timezone);
              return (
                <FormControlLabel
                  key={`${option.startTime}-${option.resources.map(r => r.providerId).join(',')}`}
                  control={<Radio />}
                  checked={option.startTime === selectedOption?.startTime && option.index === selectedOption?.index}
                  onChange={() => setSelectedOption(option)}
                  label={time}
                />
              );
            })}
          </Stack>
        </RadioGroup>
      </FormControl>
    </Alert>
  );
}
